/* eslint no-use-before-define: ["error", { "functions": false }] */
const INITIAL_STATE = {
  token: null,
  isLoading: false,
  hasError: false,
};

const strategies = {
  '@auth/SIGN_IN_REQUEST': signinRequest,
  '@auth/SIGN_UP_REQUEST': signupRequest,
  '@auth/SIGN_IN_SUCCESS': signinSuccess,
  '@auth/SIGN_FAILURE': signFailure,
  '@auth/SIGN_OUT': signout,
  '@auth/RESET_ERRORS': resetErrors,
  __default__: (state) => state,
};

export default function auth(state = INITIAL_STATE, action) {
  const transformer = strategies[action.type] || strategies.__default__;
  return transformer(state, action);
}

function signinRequest(state, action) {
  return { ...state, isLoading: true };
}

function signupRequest(state, action) {
  return { ...state, isLoading: true };
}

function signinSuccess(state, action) {
  return {
    ...state,
    token: action.payload.token,
    isLoading: false,
    hasError: false,
  };
}

function signFailure(state, action) {
  return { ...state, isLoading: false, hasError: true };
}

function signout(state, action) {
  return { ...state, token: null, isLoading: false, hasError: false };
}

function resetErrors(state, action) {
  return { ...state, isLoading: false, hasError: false };
}
